import { request } from '@/api/_service.js';
export function listBrand(params) {
  return request({
    url: '/erpProductBrands/getErpProductBrandsList',
    method: 'get',
    params: params
  });
}